import Iconify from '../Iconify';

// ------------------------------------------------------------------------------------------------------
interface AlertIconProps {
  isFail: boolean;
  sx: object;
}

export const AlertIcon = ({ isFail, sx }: AlertIconProps) => {
  if (isFail) {
    return <Iconify icon={'carbon:close-outline'} sx={{ color: 'error.main', width: 100, height: 100, ...sx }} />;
  }

  return <Iconify icon={'carbon:checkmark-outline'} sx={{ color: 'success.main', width: 100, height: 100, ...sx }} />;
};
